export const LISTING = "DELAY_BONUS_SETTING_LIST";
export const DROPDOWN = "DELAY_BONUS_SETTING_DROPDOWN";
export const STORE = "DELAY_BONUS_SETTING_STORE";
export const DETAILS = "DELAY_BONUS_SETTING_DETAILS";
export const UPDATE = "DELAY_BONUS_SETTING_UPDATE";